module.exports = __webpack_public_path__ + "static/media/check-mark-black.37ac755e.svg";